import React, { FC } from 'react';
// TODO: update to the jss
import 'assets/css/sentry-fallback.css';

export const SentryFallback: FC = () => {
  return (
    <div className="sentry-fallback-container">
      <h1>Oops..!</h1>
      <p>Something went wrong...</p>
    </div>
  );
};
